export const SET_EVENTS = 'SET_EVENTS';
export const LOAD_TASKS = 'LOAD_TASKS';
export const TOGGLE_OPEN = 'TOGGLE_OPEN';
export const SET_ALL_LOADED = 'SET_ALL_LOADED';
export const REFRESH_LOAD_STATE = 'REFRESH_LOAD_STATE';
